// src/components/validate.js (adjust path as needed)
import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        legal_representative: string().required(REQUIRED_TEXT).nullable(),
        phone: string().required(REQUIRED_TEXT).nullable(),
        email: string()
            .email('Must be a valid email')
            .required(REQUIRED_TEXT)
            .nullable(),
        city: string().required(REQUIRED_TEXT).nullable(),
    });
};
